import { createStyles, makeStyles } from '@material-ui/core';
import { fade } from '@material-ui/core/styles/colorManipulator';

export default makeStyles((theme) =>
  createStyles({
    panel: {
      position: 'sticky',
      bottom: 0,
      left: 0,
      right: 0,
      minHeight: 64,
      zIndex: theme.zIndex.appBar,
      borderRadius: 0,
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      marginBottom: theme.spacing(2),
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,

      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'stretch',
        minHeight: 'auto',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        gap: theme.spacing(2),
      },
    },
    selectionCount: {
      fontWeight: 500,
    },
    divider: {
      margin: theme.spacing(1, 0),
      backgroundColor: fade(theme.palette.primary.contrastText, 0.5),

      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(0),
        width: '100%',
        height: 1,
      },
    },
    empty: {
      color: theme.palette.primary.contrastText,
      opacity: 0.7,
    },
    actionsWrapper: {
      minHeight: 36.5,
      display: 'flex',
      alignItems: 'center',
      flex: 1,
      minWidth: 0,

      '& > div.MuiGrid-root:first-child': {
        justifyContent: 'flex-start',
      },

      '& .MuiIconButton-root': {
        color: theme.palette.primary.contrastText,
        border: `1px solid ${theme.palette.primary.contrastText}`,

        '&:hover': {
          border: `1px solid ${fade(theme.palette.primary.contrastText, 0.5)}`,
        },
      },

      // Стили для Tabs внутри actionsWrapper
      '& .MuiTabs-root': {
        minHeight: 'auto',
        width: '100%',
      },

      '& .MuiTabs-flexContainer': {
        gap: theme.spacing(1), // Добавляем отступы между кнопками

        '& > *': {
          flexShrink: 0, // Предотвращаем сжатие кнопок
          minWidth: 'auto', // Убираем минимальную ширину табов
        },
      },
    },
    selectedContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.25),

      '& .MuiIconButton-root': {
        color: theme.palette.primary.contrastText,

        '&:hover': {
          color: theme.palette.primary.contrastText,
        },
      },
    },
  })
);
